import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux/es/hooks/useSelector";
import MuiAppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import { Toolbar, Typography, Tooltip, Grid } from "@mui/material";
import coLogo from "../images/Crothall_Logo_RGB_Small.png";
import { SelectFacility } from "../common/selectFacility";

export const FlowHeader = (props) => {
  const { open, callOnClick } = props;
  const navigate = useNavigate();
  const loggedInUser = JSON.parse(localStorage.getItem("currentUser"));
  const selectedValues = useSelector((state) => state.SelectedValues);

  const logoutHandler = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("currentSsoUser");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("store");
    navigate("/logout");
  };

  return (
    <>
      <MuiAppBar
        position="relative"
        sx={{
          width: `210px`,
          height: "65px",
          backgroundColor: "white",
          borderBottom: "1px solid lightGrey",
        }}
      >
        <Toolbar>
          <Tooltip title="Open Menu options">
            <img
              alt="Compass"
              src={coLogo}
              style={{ display: "flex", height: "30" }}
            />
          </Tooltip>
        </Toolbar>
      </MuiAppBar>
      <MuiAppBar
        position="fixed"
        sx={{
          marginLeft: "210px",
          width: `calc(100% - 210px)`,
          boxShadow: "0px 1px 0px 0px rgba(0,0,0,0.2);",
        }}
      >
        <Toolbar sx={{ backgroundColor: "white" }}>
          <Grid container sx={{ display: "flex" }}>
            <Grid item xs={3} sx={{ display: "flex" }}>
              <IconButton
                color="#3a8ddd"
                aria-label="open drawer"
                onClick={callOnClick}
                edge="start"
                sx={{
                  marginRight: 2,
                  ...(open && { display: "flex" }),
                }}
              >
                {!open && <MenuIcon sx={{ color: "#3a8ddd" }} />}
                {open && <ChevronLeftIcon sx={{ color: "#3a8ddd" }} />}
              </IconButton>
              <Typography
                noWrap
                component="div"
                sx={{
                  fontSize: "18px",
                  paddingTop: "4px",
                  paddingRight: "7px",
                  color: "#3a8ddd",
                }}
              >
                {selectedValues.activeMenu ? selectedValues.activeMenu : ""}
              </Typography>
              <Typography
                noWrap
                component="div"
                sx={{ fontSize: "18px", paddingTop: "4px", color: "#000000" }}
              >
                {selectedValues.activeComponent
                  ? " / " + selectedValues.activeComponent
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              {selectedValues.displayFacilityDDL && <SelectFacility />}
            </Grid>
            <Typography
              sx={{ fontSize: "18px", marginLeft: "auto", color: "#3a8ddd" }}
            >
              Welcome {loggedInUser?.displayName}
              <IconButton
                onClick={logoutHandler}
                aria-label="Logout"
                color="#3a8ddd"
                sx={{
                  marginLeft: 2,
                }}
              >
                <LogoutIcon sx={{ color: "#3a8ddd" }} />
              </IconButton>
            </Typography>
          </Grid>
        </Toolbar>
      </MuiAppBar>
    </>
  );
};
